@if (hero(); as hero) {
  <div class="hero-heading">
    <div class="hero-heading__container">
      <h1
        class="hero-heading__title display-heading-font-family"
        [class.hero-heading__title--plain]="!hasEssentRebranding()"
        [class.hero-heading__title--rebranding]="hasEssentRebranding()"
      >
        @if (headingLine1(); as headingLine1) {
          <span class="hero-heading__line1" *scText="headingLine1"> </span>
        }
        @if (headingLine2(); as headingLine2) {
          <span class="hero-heading__line2" *scText="headingLine2"> </span>
        }
      </h1>

      @if (showButtonGroup()) {
        <div class="hero-heading__button-group">
          <wl-hero-button-group
            [hero]="hero"
            [inverted]="false"
            [large]="true"
          />
        </div>
      }
    </div>
  </div>
}
